import axios from "./searchInstance"
import {Hit, SearchResult} from "@/types/search";

type Filters = {
    orders: boolean;
    products: boolean;
}

export type SearchByTermResult = {
    hits: Hit[];
    // Elasticsearch reports the full match count, so callers can page through
    // results without fetching them all.
    total: number;
}

export default async (term: string, filters: Filters, page = 1, size = 100): Promise<SearchByTermResult> => {
    let params: {term: string, page: number, size: number, index?: string} = {
        term,
        page,
        size,
    }

    if (filters.orders && !filters.products) params['index'] = 'order'
    if (!filters.orders && filters.products) params['index'] = 'product'

    // Errors are intentionally not swallowed here: the caller needs to tell the
    // difference between "no results" and "the search API is down".
    const response = await axios.get<SearchResult>(``, { params: { ...params } });

    return {
        hits: response.data?.hits?.hits ?? [],
        total: response.data?.hits?.total?.value ?? 0,
    }
}
